import axiosInstance from '@/services/axios/api';
import toastService from '@/services/globals/toast.service';
import router from '@/routes';
const { state, actions } = useOidcStore();
import { useStore } from '@/store';
import { computed } from 'vue';
import { useOidcStore } from 'vue3-oidc';
import { LoaderActionTypes } from '@/store/loader/action-types';
import { parseApiError } from '@/extensions/serverValidation';
const userManager = computed(() => state.value.userManager);
const accessDeniedRoutes = ['denied', 'accessdenied'];

function normalizeMessage(message: string): string {
  return message
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

function isUsuarioInativoError(message?: string): boolean {
  if (!message) return false;
  return normalizeMessage(message).includes('usuario inativo');
}

function redirectToAccessDenied() {
  if (accessDeniedRoutes.includes(router.currentRoute.value.name?.toString() ?? '')) return;
  router.replace({ name: 'denied' });
}

const setup = async () => {
  axiosInstance.interceptors.request.use(async (config) => {
    const controller = new AbortController();
    const cfg = {
      ...config,
      signal: controller.signal
    };
    const obraSelected = useStore().getters.getObraSelecionada;

    if (
      !config.url?.includes('/segUsuario/IntegraUsuario') &&
      !config.url?.includes('/user/GetContratos') &&
      !config.url?.includes('/gesobra/ListByUsuario') &&
      !config.url?.includes('gesregional') &&
      !config.url?.includes('GesObra') &&
      !config.url?.includes('/graphql/') &&
      (!obraSelected || Object.keys(obraSelected).length == 0)
    ) {
      toastService.alertaErro('Obra não selecionada');
      controller.abort('Obra não selecionada, abortando requisição');
      return cfg;
    }

    const isLegacy = useStore().getters.getIsLegacy;
    const tokenLegacy = useStore().getters.getTokenLegacy;
    const tokenLegacyDeserialized = useStore().getters.getTokenLegacyDeserialized;
    if (obraSelected) {
      if (config.url?.indexOf('?') != -1)
        config.url += `${obraSelected.gesObraId ? '&gesObraSelecionadaId=' + obraSelected.gesObraId : ''}${isLegacy ? `&isLegacy=true&codigoContrato=${tokenLegacyDeserialized.codigoContrato}` : ''}`;
      else
        config.url += `${obraSelected.gesObraId ? '?gesObraSelecionadaId=' + obraSelected.gesObraId : ''}${isLegacy ? `&isLegacy=true&codigoContrato=${tokenLegacyDeserialized.codigoContrato}` : ''}`;
    }

    const tipoMeta = router.currentRoute.value.meta?.utlTipoFornecimentoId;
    const paramsObj = (config.params ?? {}) as Record<string, any>;

    // Rotas agregadoras podem possuir mais de um tipo; nesse caso nao existe
    // um contexto unico e seguro para a telemetria da requisicao.
    if (typeof tipoMeta === 'number' && Number.isInteger(tipoMeta) && paramsObj.utlTipoFornecimentoId == null) {
      config.params = {
        ...paramsObj,
        utlTipoFornecimentoId: tipoMeta
      };
    }

    if (!isLegacy) {
      let user = await userManager.value?.getUser();
      try {
        if (user && user.expired) {
          useStore().dispatch(LoaderActionTypes.ACTION_SHOW);
          user = await userManager.value?.signinSilent();
          actions.value.setUser(user!);
          useStore().dispatch(LoaderActionTypes.ACTION_HIDE);
        }

        // if (!config.url?.includes("/user/GetContratos") && !config.url?.includes("/gesobra/ListByUsuario") && !(user?.profile.role as string[]).includes("Admin") && !(user?.profile.role as string[]).includes("Suporte")) {
        //   toastService.alertaErro('Usuário não cadastrado no nosso sistema, entre em contato com o suporte.');
        //   controller.abort('Usuário não cadastrado no nosso sistema, entre em contato com o suporte.');
        //   return cfg;
        // }
      } catch {
        LoaderActionTypes.ACTION_HIDE;
      }

      config.headers!['Authorization'] = 'Bearer ' + user?.access_token;
      if (!config.url?.includes("/user/GetContratos")) {
        const codContrato = useStore().getters.getCodigoContrato;
        config.headers!['Contrato'] = codContrato;
      }
    } else config.headers!['Authorization'] = 'Bearer ' + tokenLegacy;
    //     const cont= opentelemetry.context.active();
    //  const hr= opentelemetry.propagation.inject(opentelemetry.context.active(),{})!;
    //       config.headers = hr;

    return config;
  });

  axiosInstance.interceptors.response.use(
    (res) => {
      // const span = (spanPool[res.config.headers!['parentSpanId'] as string]) as Span;
      // delete spanPool[res.config.headers!['parentSpanId'] as string];
      // span.end();

      return res;
    },
    async (err) => {
      if (err.code == 'ERR_CANCELED') {
        return Promise.reject(err);
      }
      const originalConfig = err.config ?? {};
      const apiError = parseApiError(err);
      console.error('Erro em requisição Axios', err);
      if (originalConfig.url !== '/auth/login' && err.response) {
        // Access Token was expired
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true;
        } else if (err.response.status === 403 && !originalConfig._retry) {
          originalConfig._retry = true;
          // Só usuário inativo vai para a tela de acesso negado — aí a sessão inteira está bloqueada.
          // 403 de permissão granular derruba apenas a requisição (muitas vezes um filtro ou um
          // botão secundário da tela): avisa e deixa o usuário onde está.
          if (isUsuarioInativoError(apiError.message)) {
            redirectToAccessDenied();
            return Promise.reject(err);
          }
          toastService.alertaErro('Você não tem permissão para essa ação.');
        } else if (err.response.status === 422 && !originalConfig._retry) {
          originalConfig._retry = true;

          if (apiError.id === 8) {
            toastService.alertaErro('Existem campos inválidos no formulário.');
          } else if (apiError.message) {
            toastService.alertaErro(apiError.message);
          } else {
            toastService.alertaErro('Erro desconhecido, tente novamente ou entre em contato com o suporte.');
          }
        } else if (err.response.status === 400 && !originalConfig._retry) {
          originalConfig._retry = true;
          if (isUsuarioInativoError(apiError.message)) {
            redirectToAccessDenied();
            return Promise.reject(err);
          }
          if (err.response.data.Message) toastService.alertaErro(err.response.data.Message);
          else toastService.alertaErro('Erro desconhecido, tente novamente ou entre em contato com o suporte.');
        } else if (err.response.status === 500 && !originalConfig._retry) {
          toastService.alertaErro('Erro desconhecido, tente novamente ou entre em contato com o suporte.');
        }
      }
      return Promise.reject(err);
    }
  );
};
export default setup;
